import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-162f2e79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-select-item" }
const _hoisted_2 = { class: "account-select-item__info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "account-select-item__info-block" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

import { Account } from "@/types/account";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'account-select-item',
  props: {
  account: {
    type: Object as PropType<Account>,
    default: null,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.account.image,
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (__props.account.name)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_5, [
              _createTextVNode(_toDisplayString(__props.account.name) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.replaceWithEllipsis(__props.account.address, 6, 6)), 1)
            ]))
          : (_openBlock(), _createElementBlock("h3", _hoisted_6, _toDisplayString(__props.account.address), 1)),
        (__props.account.isLedger)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Ledger"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})